import { createStyles } from 'antd-style'

import { useMergedRef } from '@eastcoal/common/hooks/useMergedRef'
import { pick } from '@eastcoal/common/utils/object'

import { useAttachmentCardStore } from '../Store/hooks/useStore'

import { AttachmentItemProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  item: {
    display: 'inline-flex',
    alignItems: 'center'
  },
  filename: {
    marginInlineStart: token.paddingXXS
  }
}))

export const AttachmentItem = ({
  ref,
  className,
  style,
  filename,
  icon,
  ...restProps
}: AttachmentItemProps) => {
  const { cardRef } = useAttachmentCardStore(state => pick(state, ['cardRef']))

  const mergedRef = useMergedRef(cardRef, ref)

  const { cx, styles } = useStyles()

  return (
    <div
      ref={mergedRef}
      className={cx(styles.item, className)}
      role='button'
      style={style}
      tabIndex={-1}
      {...restProps}
    >
      {icon}
      <span className={styles.filename}>{filename}</span>
    </div>
  )
}
